/**
 * Basis tool voor het afhandelen van async communicatie. Hier is eventueel nog een standaard error afhandeling tussen te hangen.
 */

/**
 * Fetches data from the given URL using a GET request.
 *
 * @async
 * @function getUrl
 * @param {string} url - The URL to fetch data from.
 * @returns {Promise<{status: number, data: any}>} The response status and data.
 */
const getUrl = async (url) => {
  const options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
    },
  };
  let response = await fetch(url, options);
  let status = response.status;
  let data = await response.json();

  return { status, data: data };
};

/**
 * Sends data to the given URL using a POST request.
 *
 * @async
 * @function postUrl
 * @param {string} url - The URL to send data to.
 * @param {Object} postData - The data to send in the body of the POST request.
 * @returns {Promise<{status: number, data: any}>} The response status and data.
 */
const postUrl = async (url, postData) => {
  const options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
    },
    body: JSON.stringify(postData),
  };
  let response = await fetch(url, options);
  let status = response.status;
  let data = null;
  try {
    data = await response?.json();
  } catch (error) {}
  return { status, data };
};

const AsyncHelper = () => {
  return { getUrl, postUrl };
};

export { AsyncHelper };
